<script lang="ts">
/**
 * Standard study “card” (`.ca`): optional `.ic` glyph, title, body paragraph, optional footer
 * (`.vl` / `.vs`). Omit `icon` when the emoji lives in `title` (IMX data list slides).
 *
 * `text`, `footerValue`, and `footerCaption` use `{@html}` for entities / light markup — trusted
 * study copy only.
 */
interface Props {
  title: string
  /** Main paragraph */
  text: string
  icon?: string
  cardClass?: string
  cardStyle?: string
  titleClass?: string
  titleStyle?: string
  /** Large value line in footer (`.vl`) */
  footerValue?: string
  /** Subline under footer value (`.vs`) */
  footerCaption?: string
}

let {
  title,
  text,
  icon,
  cardClass = '',
  cardStyle,
  titleClass = '',
  titleStyle,
  footerValue,
  footerCaption,
}: Props = $props()
</script>

<div class="ca {cardClass}" style={cardStyle}>
  {#if icon}
    <div class="ic">{icon}</div>
  {/if}
  <h4 class={titleClass} style={titleStyle}>{title}</h4>
  <p>{@html text}</p>
  {#if footerValue != null && footerValue !== ''}
    <div class="vl">{@html footerValue}</div>
  {/if}
  {#if footerCaption != null && footerCaption !== ''}
    <div class="vs">{@html footerCaption}</div>
  {/if}
</div>
